import {connectedRouterRedirect} from 'redux-auth-wrapper/history4/redirect'
import {CERTIFICATE_REQUEST_PKCS10_ROUTE, CERTIFICATE_REQUEST_ROUTE} from "./routes";

const privateRoute = connectedRouterRedirect({
  redirectPath: '/',
  allowRedirectBack: false,
  "authenticatedSelector": (state) => {
    let isLogged=state.auth.logged;
    if(isLogged==null)
      isLogged=true;
    let publicRoutes=[CERTIFICATE_REQUEST_ROUTE,CERTIFICATE_REQUEST_PKCS10_ROUTE];
    let currentRoute=state.router.location.pathname;
    let isPublic=false;
    for(let i=0;i<publicRoutes.length;i++)
    {
      if(publicRoutes[i]===currentRoute)
      {
        isPublic=true;
        break;
      }
    }
    let value=(isPublic && state.auth.isRA) || isLogged;
    return value;
  },
  wrapperDisplayName: 'PrivateRoute'
});

export default privateRoute;
